<template>
  <div class="search-section">
    <div class="divider">
      <h4>بحث في أقساط الشركات</h4>
      <hr
        role="separator"
        aria-orientation="horizontal"
        class="v-divider theme--dark"
      />
    </div>
    <div class="row">

      <div class="col-lg-4 py-0">
        <div class="input_wrapper top_label auto_complete">
          <label class="form-label"> صاحب الإستحقاق</label>
          <v-autocomplete
            v-model="searchData.company"
            :search-input.sync="searchOptions.search_companies"
            @change="$emit('filterTable', searchData)"
            :items="companies"
            item-text="company"
            item-value="company"
            :hide-no-data="!companies"
            dense
          ></v-autocomplete>
          <button class="button_style_1 load_inline" v-if="load_companies">
            <span class="btn_loader"></span>
          </button>
        </div>
      </div>
      <div class="col-lg-4 py-0">
        <div class="input_wrapper top_label date_input">
          <label class="form-label">من</label>
          <v-menu
            ref="to_date_menu"
            v-model="searchOptions.from_date_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="searchData.from"
                label="Date"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="searchData.from"
              @input="searchOptions.from_date_menu = false"
              no-title
              scrollable
            >
            </v-date-picker>
          </v-menu>
        </div>
      </div>
      <div class="col-lg-4 py-0">
        <div class="input_wrapper top_label date_input">
          <label class="form-label">إلي</label>
          <v-menu
            ref="to_date_menu"
            v-model="searchOptions.to_date_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="searchData.to"
                label="Date"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="searchData.to"
              @input="searchOptions.to_date_menu = false"
              no-title
              scrollable
            >
            </v-date-picker>
          </v-menu>
        </div>
      </div>
      <div class="col-lg-12 text-center py-0">
        <button
          class="button_style_1"
          @click="$emit('filterTable', searchData)"
        >
          بحث
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      load_users: false,
      load_companies: false,

      // search
      searchData: {
        company: "",
        username: null,
        from: new Date().toISOString().slice(0, 10),
        to: new Date().toISOString().slice(0, 10),
      },
      searchOptions: {
        search_users: "",
        search_companies: "",
        from_date_menu: false,
        to_date_menu: false,
      },
      users: null,
      companies: null,
    };
  },
  watch: {

    [`searchOptions.search_companies`](newVal, oldVal) {
      if (!newVal || newVal.length < 3) {
        this.companies = null;
      } else {
        if (!newVal & (oldVal == "")) {
          this.get_filterd_companies(oldVal);
        } else if ((newVal == "") & (oldVal != "")) {
          this.get_filterd_companies(newVal);
        } else {
          this.get_filterd_companies(newVal);
        }
      }
    },
  },
  methods: {

    // get_filterd_companies
    get_filterd_companies(keyword) {
      this.load_companies = true;
      this.$axios({
        method: "GET",
        url: `client/installment?company_name=${keyword}`,
      })
        .then((res) => {
          this.companies = res.data.data;
          this.load_companies = false;
        })
        .catch((err) => {
          this.load_companies = false;
        });
    },
  },
};
</script>

<style lang="scss">
.search-section .load_inline {
  width: 30px !important;
  height: 25px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 0 !important;
  left: 1px;
  position: absolute !important;
  background: transparent !important;
  margin: 0 !important;

  span {
    right: 0 !important;
    left: 0 !important;
    margin: auto !important;
    border-top: 3px solid var(--mainColor-2) !important;
    border-right: 3px solid transparent !important;
  }
}
</style>

